<template>
    <DFormRow
        :label="__('customers.contracts.existing_contract')"
        :error="errors.existing_contract"
    >
        <div
            role="group"
            class="form-group"
        >
            <DSwitch
                :model-value="modelValue"
                color="success"
                variant="3d"
                @update:modelValue="$emit('update:modelValue', $event)"
                @update:checked="existingContractChanged"
            />
        </div>
    </DFormRow>
</template>

<script>
export default {
    name: 'ExistingContract',
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['existingContractChanged', 'update:modelValue'],
    methods: {
        existingContractChanged (value) {
            this.$emit('existingContractChanged', value)
        }
    }
}
</script>
